import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { PermissionTypesEnum, TransportationTypeEnum } from '@api/ringil-api.v2';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import CreateSupplierNotificationDap, {
  SupplierNotificationDapForm,
} from '@app/pages/dap/CreateSupplierNotificationDap.tsx';
import { emptyOrder } from '@components/framework/orders/common.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CreateSupplierNotificationDapPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  const initialData: SupplierNotificationDapForm = {
    transportationType: TransportationTypeEnum.GROUND,
    attachments: [],
    orders: [emptyOrder(true)],
    companyId: null,
    supplierId: null,
    supplierLocationId: null,
    customerLocationId: null,
    notifyData: {
      notifyUsersDependsOnRole: true,
      responsiblePerson: null,
      userToNotify: [],
    },
    loadingGlobalTimeslots: { dayWithInterval: [], timezoneId: null },
    unloadingGlobalTimeslots: { dayWithInterval: [], timezoneId: null },
    carrierName: null,
    shipmentNumber: null,
    labels: [],
  };

  return (
    <>
      <ResponsiveLayout
        title={tr(`CreateSupplierNotificationDapPage.createSupplierNotificationDap`, `Vytvořit DAP avizaci`)}
        oneOfPermission={[PermissionTypesEnum.PERMISSION_SN_DXX_CREATE]}>
        <CreateSupplierNotificationDap initialData={initialData} />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(CreateSupplierNotificationDapPage);
